module.exports = __webpack_public_path__ + "static/media/jackpot.da6db2bb.gif";